var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 59,
    viewBox: "0 0 155 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6944 0.666674H58.9986C52.0048 0.570258 45.1967 2.91779 39.7486 7.30429C34.3006 11.6908 30.5543 17.8412 29.1561 24.6945H0.611115V34.3056H29.1081C30.4818 41.18 34.228 47.3529 39.6919 51.7451C45.1558 56.1373 51.9896 58.4692 58.9986 58.3333H72.6944V0.666674Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.661 24.6945C125.26 17.8247 121.499 11.6617 116.031 7.27327C110.563 2.88487 103.732 0.547672 96.7222 0.666684H82.3056V58.3334H96.7222C103.731 58.4693 110.565 56.1373 116.029 51.7451C121.493 47.3529 125.239 41.18 126.613 34.3056H154.389V24.6945H126.661Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.009b296b994ae0277dda74570f4d11f9.svg";
export { ForwardRef as ReactComponent };